import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import * as _ from 'underscore';
import * as moment from 'moment';
import { VoucherService } from 'src/app/api/billing/voucher.service';
declare var $: any;

@Component({
  selector: 'app-vouchers-report',
  templateUrl: './vouchers-report.component.html',
  styleUrls: ['./vouchers-report.component.css']
})
export class VouchersReportComponent {
  private thisComponent: VouchersReportComponent;

  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  start_range: any = moment().startOf('month');
  end_range: any = moment().endOf('month');

  // variables
  typevoucher_boleta: any = null;
  typevoucher_factura: any = null;
  typevoucher_recibo: any = null;
  typedocument_ruc: any = null;

  transactions: any = [];
  currencies: any = [];
  paymentmethods: any = [];
  accountbanks: any = [];
  typevouchers: any = [];
  series: any = [];

  // array variables
  detail_credit_parts: any = [];

  // obj variables
  typeVoucherSelected: any = null;
  serieSelected: any = null;
  currencySelected: any = null ;

  paymentMethodSelected: any = {};
  clientSelected: any = null;
  transactionSelected: any = 1; //por defecto tipo transaccion al contado
  warehousesSelected: any = null;
  fileUrlImage: any = null;

  constructor(
    private router: Router,
    private generalService: GeneralService,
    private voucherService: VoucherService,
    private globalService: GlobalService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.getTypeVoucherSale();
    this.getCurrencies();
    this.generateCalendar();
  }

  generateCalendar(){
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker({
      locale: {
        format: 'YYYY-MM-DD'
      },
      startDate: component_.start_range,
      endDate: component_.end_range,
      showDropdowns: true,
    },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
      }  
    );
  }

  // generateCalendar() {
  //   const component_ = this.thisComponent;
  
  //   (<any>$('#date_range')).daterangepicker(
  //     {
  //       locale: {
  //         format: 'YYYY-MM-DD',
  //         applyLabel: 'Aplicar',
  //         cancelLabel: 'Cancelar',
  //         customRangeLabel: 'Personalizado',
  //       },
  //       startDate: component_.start_range,
  //       endDate: component_.end_range,
  //       showDropdowns: true,
  //       ranges: {
  //         'Hoy': [moment(), moment()],
  //         'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
  //         'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
  //         'Mes actual': [moment().startOf('month'), moment().endOf('month')],
  //         'Mes anterior': [
  //           moment().subtract(1, 'month').startOf('month'),
  //           moment().subtract(1, 'month').endOf('month')
  //         ],
  //         'Últimos 3 meses': [
  //           moment().subtract(3, 'month').startOf('month'),
  //           moment().endOf('month')
  //         ],
  //         'Últimos 6 meses': [
  //           moment().subtract(6, 'month').startOf('month'),
  //           moment().endOf('month')
  //         ],
  //         'Último año': [
  //           moment().subtract(1, 'year').startOf('year'),
  //           moment().subtract(1, 'year').endOf('year')
  //         ],
  //         'Año actual': [moment().startOf('year'), moment().endOf('year')]
  //       }
  //     },
  //     function (start_date: any, end_date: any) {
  //       component_.start_range = start_date;
  //       component_.end_range = end_date;
  //     }
  //   );
  // }
  

  getTypeVoucherSale() {
    this.generalService.listTypeVoucherSale().subscribe({
      next: (data: any) => {
        this.typevouchers = data.results;
      }
    });
  }

  changeTypeVoucher() {
    this.series = [];
    this.serieSelected = null;
    if (!_.isNull(this.typeVoucherSelected)) {
      this.getSerieVoucher(this.typeVoucherSelected);
    }
  }

  getSerieVoucher(typevoucher_id: any) {
    this.generalService.getSerieTypeVoucher(typevoucher_id).subscribe({
      next: (data: any) => {
        this.series = data.results;
      }
    });
  }

  getCurrencies() {
    this.generalService.listCurrencies().subscribe({
      next: (data: any) => {
        this.currencies = data.results;
        this.currencySelected = this.currencies[0].id;
      }
    });
  }

  generateReport() {
    this.list();
  }

  list() {
    let val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&start_range=' +
      this.start_range.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range.format('YYYY-MM-DD') +
      '&typeVoucherSelected=' +
      this.typeVoucherSelected+
      '&serieSelected=' +
      this.serieSelected+
      '&currencySelected=' +
      this.currencySelected;

    this.voucherService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;

        setTimeout(() => {
          this.initPopovers();
        }, 150); 
      }
    });
  }

  initPopovers() {
    // destruye popovers previos para evitar duplicados
    ($('[data-toggle="popover"]') as any).popover('dispose');
    // inicializa
    ($('[data-toggle="popover"]') as any).popover({
      html: true,
      trigger: 'hover click', // ajusta según necesites
      placement: 'right'
    });
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.typeVoucherSelected = null;
    this.serieSelected = null;
    this.start_range = moment().startOf('month');
    this.end_range = moment().endOf('month');
    this.generateCalendar();
    this.list();
  }

  downloadExcel() {
    const params =
      'search=' + this.params.search +
      '&start_range=' + this.start_range.format('YYYY-MM-DD') +
      '&end_range=' + this.end_range.format('YYYY-MM-DD') +
      '&typeVoucherSelected=' + this.typeVoucherSelected +
      '&serieSelected=' + this.serieSelected+
      '&currencySelected=' + this.currencySelected;
  
    const url = `/${this.branchofficeSlug}/api/vouchers/list/export/excel?${params}`;
    window.open(url, '_blank');
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reportes/lista']);
  }
}
